import {
  CLOSE_MODAL,
  OPEN_MODAL,
} from './actionTypes';

export const actionCloseModal = () => ({
  type: CLOSE_MODAL,
});

export const actionOpenModal = (payload) => ({
  type: OPEN_MODAL,
  payload,
});
